<template>
  <div class="file-item">
    <a-icon title="点击删除" @click="handelDel" class="del-icon" type="close" />
    <img title="点击预览" class="pic" v-if="isImg" @click="visible = true" :src="src" alt="" />
    <template v-else>
      <video title="点击预览" class="media-videl" @click="visible = true" :src="src" />
      <a-icon title="点击预览" @click="visible = true" class="play-icon" type="play-circle" />
    </template>
    <a-modal :destroyOnClose="true" style="width: 900px" title="预览" :keyboard="true" v-model="visible" :footer="null">
      <img v-if="isImg" style="width: 100%" :src="src" alt="" />
      <video controls style="width: 100%" v-else :src="src" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    isImg: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    handelDel() {
      const type = this.isImg ? '图片' : '视频'
      this.$confirm({
        title: `是否确定删除该${type}?`,
        onOk: () => {
          this.$emit('delItem', this.index)
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.file-item {
  position: relative;
  width: 300px;
  height: 170px;
  margin: 0 20px 20px 0;
  border: 1px solid #ccc;
  &:hover {
    box-shadow: 4px 4px 2px #cecece;
  }
  .del-icon {
    position: absolute;
    top: 2px;
    right: 2px;
    cursor: pointer;
    font-size: 16px;
    &:hover {
      color: #F56C6C;
    }
  }
  .pic {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: contain;
    cursor: pointer;
  }
  .media-videl {
    width: 95%;
    height: 100%;
    cursor: pointer;
  }
  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #d1d1d1;
    cursor: pointer;
    font-size: 30px;
  }
}
</style>
